import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import { RenderField } from '../common/form';
import * as Validations from '../common/form/commonValidations';
import { checkSlugAvailability, getSlugSuggestions } from '../../actions/OnboardActions';

// TODO : Delete this file once slug removal goes live.

class Step3 extends Component {
  componentDidMount() {
    const { getSuggestions, slugSuggestionData } = this.props;
    getSuggestions(slugSuggestionData);
  }
  render() {
    const { handleSubmit, slugSuggestions, selectSuggestion, primaryProduct } = this.props;
    return (
      <div className="row" id="step-3">
        <div className="col-xs-12 col-sm-7 step-form text-center">
          <h3 className="onboard-step-header">
            What do you want your address to be?
          </h3>
          <div className="row padding-top padding-bottom">
            <div className="col-xs-12 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
              <p>
                Try to keep it simple–this is the link guests will use to access your wedding website or registry.
              </p>
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <Field
              name="slug"
              type="text"
              id="user-slug"
              component={RenderField}
              inputGroup={`${window.location.protocol}//${window.location.host}/${(primaryProduct === 'REGISTRY') ? 'registry' : 'wedding'}/`}
              maxChars={80}
              validate={[Validations.REQUIRED, Validations.MAX_LENGTH_80, Validations.SLUG]}
            />
            {slugSuggestions && slugSuggestions.length > 0 &&
              <div className="margin-top-2x">
                <p className="pull-left suggestions-title">Suggestions:</p>
                {slugSuggestions.map(suggestion => (
                  <span className="slug-suggestion" onClick={() => selectSuggestion(suggestion)} key={suggestion}>{suggestion}</span>
                ))}
              </div>
            }
            <div className="col-xs-12 next-button">
              <button type="submit" className="btn btn-wide btn-primary">Finish</button>
            </div>
            <div className="col-xs-12">
              <p>Already purchased your own website address?</p>
              <p>We&#39;ll show you how to connect this later.</p>
            </div>
          </form>
        </div>
        <div className="col-xs-12 col-sm-3 hidden-xs">
          <img src="/images/doodles/onboarding_4.png" srcSet="/images/doodles/onboarding_4@2x.png 2x" alt="Zola Cake" />
        </div>
      </div>
    );
  }
}

Step3.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  slugSuggestions: PropTypes.arrayOf(PropTypes.string),
  getSuggestions: PropTypes.func.isRequired,
  slugSuggestionData: PropTypes.shape({}).isRequired,
  selectSuggestion: PropTypes.func,
  primaryProduct: PropTypes.string
};

const selector = formValueSelector('onboardForm');

const mapStateToProps = state => (
  {
    primaryProduct: state.Onboard.primaryProduct,
    slugSuggestions: state.Onboard.slugSuggestions,
    isSlugAvailable: state.Onboard.isSlugAvailable,
    slugSuggestionData: {
      primaryFirstName: selector(state, 'owner_user_first_name'),
      partnerFirstName: selector(state, 'partner_user_first_name'),
      primaryLastName: selector(state, 'owner_user_last_name'),
      partnerLastName: selector(state, 'partner_user_last_name'),
      eventDate: selector(state, 'wedding_date') ? moment.utc(selector(state, 'wedding_date')).toDate() : ''
    },
    initialValues: {
      ...state.form.onboardForm.values,
      slug: (state.Onboard.slugSuggestions) ? state.Onboard.slugSuggestions[0] : ''
    }
  }
);

const mapDispatchToProps = dispatch => (
  {
    checkAvailability: (slug) => {
      dispatch(checkSlugAvailability(slug));
    },
    getSuggestions: (slugSuggestionData) => {
      dispatch(getSlugSuggestions(slugSuggestionData));
    },
    selectSuggestion: (suggestedSlug) => {
      dispatch(change('onboardForm', 'slug', suggestedSlug));
    }
  }
);

const asyncValidate = (values, dispatch) => {
  const slug = values.slug;
  return dispatch(checkSlugAvailability(slug))
    .then((response) => {
      if (!response.payload) {
        throw Object.assign({}, { slug: 'This website address is taken.' });
      }
    });
};

const Step3Form = reduxForm({
  form: 'onboardForm',
  destroyOnUnmount: false,
  asyncValidate,
  asyncBlurFields: ['slug'],
  enableReinitialize: true
})(Step3);

export default connect(mapStateToProps, mapDispatchToProps)(Step3Form);



/** WEBPACK FOOTER **
 ** ./src/components/onboard/Step3.jsx
 **/